<app-header-usuario></app-header-usuario>
<div id="hasnt-access-page" class="">
    <div id="hasnt-access-box">
        <img id="alert-icon" src="../../../assets/img/alert.svg" alt="">
        <p id="alert-title">
            Ops, parece que você não tem acesso ao portal.
        </p>
        <p id="alert-description">
            Entre em contato com o administrador da conta da sua empresa e solicite a liberação do seu acesso.
        </p>
    </div>
</div>
<app-footer></app-footer>